import React from "react";
import locale from "@bonliva-crm/locale";
import { PlainLink } from "../typography/PlainLink";
import IconTitle from "./IconTitle";
import UserAvatar from "../../containers/UserAvatar";

type Props = {
  name: string;
  onClick?: (e: React.SyntheticEvent<any>) => void;
};

export const ResponsibleSection = ({ name, onClick }: Props) => {
  if (!name) {
    return null;
  }

  return (
    <IconTitle
      title={locale["Responsible BA"]}
      icon={<UserAvatar userName={name} size="mini" />}
    >
      <PlainLink onClick={onClick}>{name}</PlainLink>
    </IconTitle>
  );
};

export default ResponsibleSection;
